import { Component, OnInit } from '@angular/core';
import { ModalNavigationComponent } from '../../services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from '../../services/gui/modal/modal-navigation.service';
import { PlaybackScheduleSlotDTO } from '../../services/api/api';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'sb-comp-slot-order-component',
  templateUrl: './slot-order.component.html',
  styleUrls: ['./slot-order.component.scss'],
  standalone: false,
})
export class SlotOrderComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;
  slots: PlaybackScheduleSlotDTO[];
  fallback: PlaybackScheduleSlotDTO[];
  disabled: boolean;
  selectedSlot: PlaybackScheduleSlotDTO;

  constructor(public modalNavigation: ModalNavigationService) {
    this.slots = [];
    this.fallback = [];
    this.disabled = false;
    this.selectedSlot = null;
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.slots = this.modalNavigation.getCurrentNavigation().data.slots;
      this.fallback = this.modalNavigation.getCurrentNavigation().data.fallback;
    }
  }

  addToFallback(slot: PlaybackScheduleSlotDTO) {
    this.fallback.push(slot);
    this.slots.splice(this.slots.indexOf(slot, 0), 1);
  }

  removeFromFallback(slot: PlaybackScheduleSlotDTO) {
    this.slots.push(slot);
    this.slots.sort((a, b) => {
      return a.orderNum - b.orderNum;
    });
    this.fallback.splice(this.fallback.indexOf(slot, 0), 1);
    if (this.selectedSlot === slot) {
      this.selectedSlot = null;
    }
  }

  selectSlot(slot: PlaybackScheduleSlotDTO) {
    if (this.selectedSlot === slot) {
      this.selectedSlot = null;
    } else {
      this.selectedSlot = slot;
    }
  }

  shiftSlot(slot: PlaybackScheduleSlotDTO, direction: number) {
    if (this.fallback.length <= 1) {
      return;
    }
    const index = this.fallback.indexOf(slot, 0);
    if (direction === -1) {
      if (index <= 0) {
        return;
      }
      const swapElement = this.fallback[index - 1];
      this.fallback[index - 1] = this.fallback[index];
      this.fallback[index] = swapElement;
    }
    if (direction === 1) {
      if (index === this.fallback.length - 1) {
        return;
      }
      const swapElement = this.fallback[index + 1];
      this.fallback[index + 1] = this.fallback[index];
      this.fallback[index] = swapElement;
    }
  }

  cancelFallback() {
    this.modalNavigation.result(null);
  }

  submitFallback() {
    this.modalNavigation.result(this.fallback);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.fallback, event.previousIndex, event.currentIndex);
    /*this.fallback.forEach((slot, idx) => {
      (slot as unknown as any).orderNum = idx;
    });

     */
  }
}
